import { UserSearchBox } from './UserSearchBox';
import { SearchEntity } from '../../../api/models';
import { b2cEnabled } from '../../../authConfig';

interface UsersFieldProps {
    heading: string;
    disabled: boolean;
    selectedEntities: SearchEntity[];
    onSelectEntity: (entity: SearchEntity) => void;
    onRemoveEntity: (entityId: string) => void;
    description?: string;
    lockedEntityIds?: string[];
}

export const UsersField = ({
    heading,
    disabled,
    selectedEntities,
    onSelectEntity,
    onRemoveEntity,
    description = 'Share your assistant with other users.',
    lockedEntityIds
}: UsersFieldProps) => (
    <>
        <h4 className={`text-lg font-semibold ${disabled ? 'text-gray-500' : 'text-jtc-very-dark-grey'}`}>
            {heading}
        </h4>
        <p className={`text-sm mb-4 ${disabled ? 'text-gray-400' : 'text-gray-500'}`}>
            {description}
        </p>
        <UserSearchBox
            onSelectEntity={onSelectEntity}
            selectedEntities={selectedEntities}
            onRemoveEntity={onRemoveEntity}
            includeB2c={b2cEnabled}
            lockedEntityIds={lockedEntityIds}
        />
        <div className="text-sm text-transparent text-right mt-1">
            0 / 0
        </div>
    </>
);
